import type { Command, Transaction } from 'prosemirror-state';

import type { TrackableImageFile } from '@core/wysiwyg-legacy';

import type { ImageNodeAttrs } from './image-node';
import { NodeName } from '../../schema/nodes';

export const createImage = (
  { id, url, width }: TrackableImageFile,
  attrs?: Partial<ImageNodeAttrs>,
): Command =>
  function (state, dispatch) {
    const { tr, selection, schema } = state;
    const pos = selection.from;
    const node = schema.nodes[NodeName.Image].create({
      src: url,
      guid: id,
      width: width || null,
      ...(attrs && attrs),
    });
    tr.insert(pos, node);
    if (dispatch) dispatch(tr);
    return true;
  };

export const updateSrc = ({ id, url }: { id: string; url: string }): Command =>
  function (state, dispatch): boolean {
    const { doc } = state;
    let tr: Transaction | undefined;
    doc.descendants((node, pos) => {
      if (node.attrs?.guid === id) {
        tr = state.tr.setNodeAttribute(pos, 'src', url);
      }
    });
    if (!tr) return false;
    if (dispatch) dispatch(tr);
    return true;
  };
